export default "__VITE_ASSET__DlQAOPl$__"